import { ColorAttributes } from "../constants/constants";

const paintReducer = (data = ColorAttributes.STATUS, action) => {
    switch(action.type){
        case 'SET_PAINT':
            data = action.data;
            return data;
        default:
            return data;
    }
}

export default paintReducer;